import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="崧燁文化"
        brandName="崧燁文化"
        englishName="SUNYA"
        tagline="醫療保健、研究與論文相關專業書籍"
      />
      <Footer />
    </>
  );
}

